<template>
  <div>
    <component :is="dashboardView"></component>
    <!-- <a-modal
      :width="300"
      style="top: 20px; width: 200px; text-align: center;"
      :visible="wechatBindModal"
      :closable="false"
      :footer="null"
      @cancel="() => closeModal(false)"
      :afterClose="showNotification"
    >
      <q-r-code v-if="wechatBindLink" :width="200" :height="200" :link="wechatBindLink"></q-r-code>
      <div class="description">
        <span>扫码绑定微信号，让你随时接收项目动态、不错过对接消息！</span>
      </div>
    </a-modal> -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { Wechats, Websocket } from '@/resources'
import { mixin } from '@/utils/mixin'
import QRCode from '@/components/tools/QRCode'
import ProjectManager from './ProjectManager'
import CollegeAdministrator from './CollegeAdministrator'

export default {
  name: 'Dashboard',
  mixins: [mixin],
  components: { QRCode, ProjectManager, CollegeAdministrator },
  data () {
    return {
      modalVisible: true,
      wechatBindLink: ''
    }
  },
  computed: {
    ...mapState({
      basicInfo: state => state.user.basicInfo
    }),
    ...mapGetters(['wechatBindModal', 'userInfoCompleteNoti']),
    dashboardView () {
      const roleMap = { administrator: 'collegeAdministrator', project_manager: 'projectManager' }
      return roleMap[this.currentRole]
    }
  },
  methods: {
    ...mapActions(['SetWechatBindModal', 'SetUserInfoCompleteNoti']),
    closeModal (visible) {
      this.SetWechatBindModal(visible)
    },
    showNotification () {
      const vm = this
      if (!vm.userInfoCompleteNoti) return
      const key = `open${Date.now()}`
      this.$notification.open({
        message: '别忘了完善您的个人信息哦',
        description: '完善的个人信息可以帮助您获得更好的个性化推送',
        icon: <a-icon type="smile" style="color: #108ee9" />,
        duration: 10,
        btn: h => {
          return h(
            'a-button',
            {
              props: {
                type: 'default',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'settings' })
                  this.$notification.close(key)
                }
              }
            },
            '去完善'
          )
        },
        key,
        onClose: () => {
          vm.SetUserInfoCompleteNoti(false)
        }
      })
    },
    socketHandler (data) {
      const vm = this
      const { event } = data
      if (event === 'bind_wechat') {
        this.SetWechatBindModal(false)
        Websocket.removeListener('NotificationChannel', vm.socketHandler)
      }
    }
  },
  async created () {
    if (this.basicInfo.wechat_nickname) {
      this.SetWechatBindModal(false)
    }
    if (this.userInfoCompleteNoti) {
      // 完善弹窗提示关闭过
      if (this.basicInfo.interestedIndustries.length && this.basicInfo.interestedTechnologyAreas.length) {
        this.SetUserInfoCompleteNoti(false)
      }
    } else {
      this.showNotification()
    }
    const { qrCode: url } = await Wechats.wechatBindQRCode({ mobile: this.basicInfo.mobile })
    this.wechatBindLink = url
  },
  mounted () {
    Websocket.addListener('NotificationChannel', this.socketHandler)
  }
}
</script>

<style lang="less" scoped>
.description {
  padding: 10px 25px 0;
  // text-align: center;
  > span {
    font-size: 14px;
    font-weight: 300;
    line-height: 22px;
    color: #666;
    text-align: justify;
  }
}
</style>
